/* styled-components & other non-external style-related exports (like, say, a `headerHeight` var) go here */
import { colors, spacing } from '@chegg-ui/theme';
import styled from 'styled-components';
export var getThemeConfig = function getThemeConfig(themeProp) {
  return {
    "default": function _default(theme) {
      return {
        boxShadow: theme.boxShadow.elevation400,
        borderRadius: theme.radius.md,
        zIndex: theme.zIndex.md
      };
    },
    prop: themeProp
  };
};
export var PopoverWrapper = styled.span.withConfig({
  componentId: "sc-19ensnf-0"
})(["position:relative;display:inline-block;"]);
export var PopoverPane = styled.div.withConfig({
  componentId: "sc-19ensnf-1"
})(["width:", ";box-shadow:", ";background-color:", ";border:1px solid ", ";border-radius:", ";position:absolute;z-index:", ";display:", ";", ""], function (_ref) {
  var width = _ref.width;
  return width;
}, function (_ref2) {
  var customTheme = _ref2.customTheme;
  return customTheme.boxShadow;
}, colors.white, colors.grey300, function (_ref3) {
  var customTheme = _ref3.customTheme;
  return customTheme.borderRadius;
}, function (_ref4) {
  var customTheme = _ref4.customTheme;
  return customTheme.zIndex;
}, function (_ref5) {
  var isShown = _ref5.isShown;
  return isShown ? 'block' : 'none';
}, function (_ref6) {
  var position = _ref6.position,
      showBeak = _ref6.showBeak;
  var spaceBetweenPaneAndElement = "calc(100% + ".concat(spacing.px8, " + ").concat(showBeak ? "".concat(22 / 16, "rem") : '0px', ")");

  switch (position) {
    case 'top':
      return "\n          bottom: ".concat(spaceBetweenPaneAndElement, ";\n          left: 50%;\n          transform: translateX(-50%);\n        ");

    case 'topRight':
      return "\n            bottom: ".concat(spaceBetweenPaneAndElement, ";\n            left: 0;\n          ");

    case 'topLeft':
      return "\n            bottom: ".concat(spaceBetweenPaneAndElement, ";\n            right: 0;\n          ");

    case 'bottomRight':
      return "\n            top: ".concat(spaceBetweenPaneAndElement, ";\n            left: 0;\n          ");

    case 'bottom':
      return "\n            top: ".concat(spaceBetweenPaneAndElement, ";\n            left: calc(50%);\n            transform: translateX(-50%);\n          ");

    case 'bottomLeft':
      return "\n            top: ".concat(spaceBetweenPaneAndElement, ";\n            right: 0;\n          ");

    case 'left':
      return "\n            top: 50%;\n            right: ".concat(spaceBetweenPaneAndElement, ";\n            transform: translateY(-50%);\n          ");

    case 'right':
      return "\n            top: 50%;\n            left: ".concat(spaceBetweenPaneAndElement, ";\n            transform: translateY(-50%);\n          ");
  }
});
export var BeakWrapper = styled.div.withConfig({
  componentId: "sc-19ensnf-2"
})(["position:absolute;> svg{display:block;}", ""], function (_ref7) {
  var position = _ref7.position;

  switch (position) {
    case 'top':
      return "\n            top: calc(100%);\n            left: 43%;\n            transform: rotate(0deg);\n          ";

    case 'topRight':
      return "\n            top: calc(100%);\n            left: 24px;\n            transform: rotate(0deg);\n          ";

    case 'topLeft':
      return "\n            top: calc(100%);\n            right: 24px;\n            transform: rotate(0deg);\n          ";

    case 'bottomRight':
      return "\n            top: -32px;\n            left: 24px;\n            transform: rotate(180deg);\n          ";

    case 'bottom':
      return "\n            top: -32px;\n            left: calc(50% - 25px);\n            transform: rotate(180deg);\n          ";

    case 'bottomLeft':
      return "\n            top: -32px;\n            right: 24px;\n            transform: rotate(180deg);\n          ";

    case 'left':
      return "\n            transform: rotate(270deg);\n            left: calc(100% - 8px);\n            top: calc(50% - 15px);\n          ";

    case 'right':
      return "\n            transform: rotate(90deg);\n            top: calc(50% - 15px);\n            left: -40px;\n          ";
  }
});